import useSWR from "swr";
import { Box } from "@mui/material";
import { useParams } from "react-router";

import AboutTitle from "../Title/Title";
import AboutTags from "../Tags/Tags";
import AboutParticipants from "../Participants/Participants";
// import AboutCircleItems from "../CircleItems/CircleItems";
import AboutDescription from "../Description/Description";
import { fetcherGetToken } from "../../../../services/fetcher";
import TableCardList from "../TableCardList";
import Category from "../Category/Category";
import ActionBtn from "../AcctionBtn";
// import SponsorLine from "../SponsorLine";

const ComponentBox = () => {
  const params = useParams();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { data: about } = useSWR(
    [
      `${process.env.REACT_APP_API}/content/table/${params.tableId}/`,
      tokenStorage,
    ],
    fetcherGetToken
  );

  return (
    <Box sx={{ padding: "0 16px" }}>
      <AboutTitle about={about} />
      <AboutParticipants about={about} />
      {/* {params.tableId == 7 && <SponsorLine />} */}
      <ActionBtn about={about} />
      <TableCardList about={about} />

      {/* <AboutCircleItems about={about} /> */}
      <AboutDescription about={about} />
      <Category about={about} />
      <AboutTags about={about} />
    </Box>
  );
};
export default ComponentBox;
